import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import Image from 'flaivy-react/components/Image';
class Avatar extends React.PureComponent {
  static get propTypes() {
    return {
      authentication: PropTypes.object.isRequired,
    };
  }

  render() {
    const {
      props: {
        authentication: {
          sessionUser: { avatar },
        },
      },
    } = this;
    return (
      <Image
        src={avatar}
        alt="user-avatar"
        resX={32}
        resY={32}
        className="rounded-circle shadow-sm"
      />
    );
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  return { authentication };
}

export default connect(mapStateToProps)(Avatar);
